import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Vuex from 'vuex'
import Vue2Filters from 'vue2-filters'

Vue.use(Vue2Filters)
Vue.use(Vuex)

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import ToggleButton from 'vue-js-toggle-button'

Vue.use(ToggleButton)

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/Pricing',
    name: 'Pricing',
    component: () => import(/* webpackChunkName: "pricing" */ '../views/info/Pricing.vue')
  },
  {
    path: '/GenerateIncome',
    name: 'GenerateIncome',
    component: () => import(/* webpackChunkName: "GenerateIncome" */ '../views/info/GenerateIncome.vue')
  },
  {
    path: '/GetApp',
    name: 'GetApp',
    component: () => import(/* webpackChunkName: "getApp" */ '../views/info/GetApp.vue')
  },
  {
    path: '/Support',
    name: 'Support',
    component: () => import(/* webpackChunkName: "Support" */ '../views/info/Support.vue')
  },
  
  {
    path: '/StartBroadcasting',
    name: 'BroadcastGuide',
    component: () => import(/* webpackChunkName: "BroadcastGuide" */ '../views/info/BroadcastGuide.vue')
  },
  {
    path: '/search',
    name: 'GlobalSearch',
    component: () => import(/* webpackChunkName: "GlobalSearch" */ '../views/GlobalSearch.vue')
  },
  
  {
    path: '/account',
    name: 'AccountDecide',
    component: () => import(/* webpackChunkName: "AccountDecide" */ '../views/accountDecide.vue')
  },
  {
    path: '/:channel',
    name: 'ChannelPage',
    component: () => import(/* webpackChunkName: "ChannelPage" */ '../views/ChannelMain.vue')
  },
  {
    path: '/broadcaster/login',
    name: 'BroadcasterLogin',
    component: () => import(/* webpackChunkName: "BroadcasterLogin" */ '../views/BroadcasterLogin.vue')
  },
  {
    path: '/broadcaster/transfer',
    name: 'BroadcasterTransfer',
    component: () => import(/* webpackChunkName: "BroadcasterTransfer" */ '../views/BroadcasterTransfer.vue')
  },
  {
    path: '/broadcaster/stripe/connect',
    name: 'SeasonPassConnect',
    component: () => import(/* webpackChunkName: "SeasonPassConnect" */ '../views/PaymentConnectStripe.vue')
  },
  {
    path: '/broadcaster/:page/:option',
    name: 'BroadcasterPageOption',
    component: () => import(/* webpackChunkName: "BroadcasterPageOption" */ '../views/BroadcasterDashboard.vue')
  },
  {
    path: '/broadcaster/:page',
    name: 'BroadcasterPage',
    chunks: ['dashboard'],
    component: () => import(/* webpackChunkName: "BroadcasterPage" */ '../views/BroadcasterDashboard.vue')
  },
  {
    path: '/:channel/recording/:recording_id',
    name: 'RecordingsWatch',
    component: () => import(/* webpackChunkName: "RecordingsWatch" */ '../views/ChannelRecording.vue')
  },
  {
    path: '/:channel/recordings',
    name: 'ChannelListRecordings',
    component: () => import(/* webpackChunkName: "ChannelListRecordings" */ '../views/ChannelListRecordings.vue')
  },
  {
    path: '/:channel/schedule', 
    name: 'ChannelSchedule',
    component: () => import(/* webpackChunkName: "ChannelSchedule" */ '../views/ChannelSchedule.vue')
  },
  {
    path: '/:channel/donate',
    name: 'ChannelDonate',
    component: () => import(/* webpackChunkName: "ChannelDonate" */ '../views/ChannelDonate.vue')
  },
  {
    path: '/viewer/login',
    name: 'ViewerLogin',
    component: () => import(/* webpackChunkName: "ViewerLogin" */ '../views/ViewerLogin.vue')
  },
  {
    path: '/viewer/create',
    name: 'Viewer Signup',
    component: () => import(/* webpackChunkName: "ViewerCreateAccount" */ '../views/ViewerCreateAccount.vue')
  },
  {
    path: '/highlight/:highlight_id',
    name: 'HighlightWatch',
    component: () => import(/* webpackChunkName: "HighlightWatch" */ '../views/HighlightWatch.vue')
  },
  {
    path: '/team/:team_id',
    name: 'Team View',
    component: () => import(/* webpackChunkName: "TeamView" */ '../views/TeamView.vue')
  },
  {
    path: '/viewer/lock/:channel_id',
    name: 'Viewer Lock',
    component: () => import(/* webpackChunkName: "ViewerLock" */ '../views/ViewerLock.vue')
  },
  {
    path: '/viewer/payment/complete/:seasonpass_id',
    name: 'Viewer Payment',
    component: () => import(/* webpackChunkName: "ViewerAddPayment" */ '../views/ViewerAddPayment.vue')
  },
  {
    path: '/viewer/dashboard/',
    name: 'Viewer Dashboard',
    component: () => import(/* webpackChunkName: "ViewerDashboard" */ '../views/ViewerDashboard.vue')
  },
  {
    path: '/viewer/payment/',
    name: 'Viewer List',
    component: () => import(/* webpackChunkName: "ViewerSeasonPassList" */ '../views/ViewerSeasonPassList.vue')
  },
  {
    path: '/viewer/highlights/create/:channel_id/:recording_id',
    name: 'Viewer List',
    component: () => import(/* webpackChunkName: "ViewerSeasonPassList" */ '../views/createHighlight.vue')
  },
  {
    path: '/recovery/forgot/',
    name: 'SendEmail',
    component: () => import(/* webpackChunkName: "SendEmail" */ '../views/recovery/SendEmail.vue')
  },
  {
    path: '/recovery/setPassword/',
    name: 'SetPassword',
    component: () => import(/* webpackChunkName: "SetPassword" */ '../views/recovery/SetPassword.vue')
  }
 
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

export default router
